import { useAccountUsersFieldConfig } from '../useAccountUsersFieldConfig';

interface UseHostFieldConfigProps {
  name: string;
  label: string;
  condition?: Record<string, unknown>;
  placeholder?: string;
}

export function useHostFieldConfig(props: UseHostFieldConfigProps) {
  const { fieldConfig } = useAccountUsersFieldConfig({
    name: props.name,
    label: 'Host',
    isMulti: false,
    condition: props.condition,
    placeholder: props.placeholder ?? 'Select host',
  });

  return { fieldConfig };
}
